import {useSuspenseQuery} from '@tanstack/react-query';
import {prepareSearchParams} from 'shared';

import {api} from '@/lib/ky';
import {extractPagination} from '@/utils/extractPagination';

import {layerTemplateSchema} from '../utils/schemas/layer';

import {layerTemplateKeys} from './queryKeys';

import type {
  ExtractFnReturnType,
  QueryConfig,
  QueryConfig2,
} from '@/lib/react-query';

export const getLayerTemplates = async (params: QueryParams = {}) => {
  const res = await api.get(`layers`, {
    searchParams: prepareSearchParams(params),
  });
  const data = await res.json();
  const pagination = extractPagination(res);

  return [layerTemplateSchema.array().parse(data), pagination] as const;
};

export const useLayerTemplates = (
  params?: QueryParams,
  config?: QueryConfig<QueryFnType>
) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: layerTemplateKeys.list(params),
    queryFn: () => getLayerTemplates(params),
  });
};
export const useLayerTemplatesLoader = (config: QueryConfig2<QueryFnType>) => {
  return useSuspenseQuery<ExtractFnReturnType<QueryFnType>>(config);
};

type QueryFnType = typeof getLayerTemplates;
type QueryParams = Parameters<typeof layerTemplateKeys.list>[0];
